import { useState } from 'react';

import { useMiniAppSDK } from '@context/SDKConfigContext.tsx';
import { useSDKHandler } from '@features/method-tester/hooks/index.ts';

import { VERSION_0_3 } from '@/constant';
import { useJsBridgeVersion } from '@/context/JsBridgeVersionContext.tsx';
import { ERROR_CODE_MESSAGE_MAP } from '@/features/method-tester/constants';
import { OPERATION_KEY } from '@/features/method-tester/types/SDKCallResult.ts';
import { Button } from '@asphalt-react/button';
import { Card } from '@asphalt-react/card';
import { Loader } from '@asphalt-react/loader';
import { Heading } from '@asphalt-react/typography';
import { GetSystemInfoResult } from '@gopay/miniapp-client';

export const SystemInfo = () => {
  const {
    isLoading,
    response: systemInfo,
    invokeSDKActionV0_3,
    invokeSDKActionV1,
  } = useSDKHandler<GetSystemInfoResult>();
  const [selectedErrorCode, setSelectedErrorCode] = useState<number | null>(
    null
  );

  const sdk = useMiniAppSDK();
  const { version } = useJsBridgeVersion();
  const getSystemInfo = async () => {
    try {
      const options = {
        ...(selectedErrorCode && {
          error: {
            operation_key: OPERATION_KEY.SYSTEM,
            code: selectedErrorCode,
          },
        }),
      };
      if (version === VERSION_0_3) {
        await invokeSDKActionV0_3(() => sdk.getSystemInfo(), options);
      } else {
        await invokeSDKActionV1('GPSystem', 'getSystemInfo', {});
      }
    } catch (error) {
      console.error(error);
    }
  };

  const resetSelection = () => setSelectedErrorCode(null);

  return (
    <Card outlined={true}>
      <div className="flex w-full justify-between">
        <Heading h6>System Info</Heading>

        <Button size="xs" onClick={getSystemInfo} disabled={isLoading}>
          Get System Details
        </Button>
      </div>
      <div className="flex gap-4">
        {ERROR_CODE_MESSAGE_MAP.device.map(({ code, message }) => (
          <label key={code} className="flex items-center gap-1">
            <input
              type="radio"
              name="ERROR_CODE"
              value={code}
              checked={selectedErrorCode === code}
              onChange={() => setSelectedErrorCode(code)}
            />
            {message}
          </label>
        ))}
      </div>
      <Button size="xs" onClick={resetSelection}>
        Reset Error Code
      </Button>
      {isLoading && <Loader />}
      {!isLoading && systemInfo && (
        <div className="mt-2 w-full">
          <pre
            data-testid="system-info-response"
            className="overflow-auto text-sm bg-gray-100 p-2 rounded"
          >
            {JSON.stringify(systemInfo, null, 2)}
          </pre>
        </div>
      )}
    </Card>
  );
};
